import {
  GET_CRM_CUSTOMER_REPORT_REQUEST,
  GET_CRM_CUSTOMER_REPORT_SUCCESS,
  GET_CRM_CUSTOMER_REPORT_ERROR,
  GET_TOP_IMMEDIATE_OTS_REQUEST,
  GET_TOP_IMMEDIATE_OTS_SUCCESS,
  GET_TOP_IMMEDIATE_OTS_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getCrmCustomerReport = (token, values) => (dispatch) => {
  dispatch({ type: GET_CRM_CUSTOMER_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/CrmShipWiseSkuImages`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      from_date: moment(values.from_date).format("MM-DD-YYYY"),
      to_date: moment(values.to_date).format("MM-DD-YYYY"),
      customer_id: values.customerNew === undefined || values.customerNew === "All" ? null : values.customerNew,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_CRM_CUSTOMER_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_CRM_CUSTOMER_REPORT_ERROR,
        payload: [],
      });
    });
};

export const getTopImmediateOts = (token, values) => (dispatch) => {
  dispatch({ type: GET_TOP_IMMEDIATE_OTS_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/TopImmediateOts`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      date_from: moment(values.from_date).format("MM-DD-YYYY"),
      date_to: moment(values.to_date).format("MM-DD-YYYY"),
      gender_id: values.gender_id === undefined || values.gender_id === "All" ? null : values.gender_id,
      current_season: values.season_id === undefined || values.season_id === "All" ? null : values.season_id,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_TOP_IMMEDIATE_OTS_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_TOP_IMMEDIATE_OTS_ERROR,
        payload: [],
      });
    });
};


